'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTeam = exports.leaveTeam = exports.joinTeam = exports.createTeam = exports.checkTeamSlugAvailable = exports.fetchTeamPages = exports.fetchTeamFitness = exports.fetchTeamBySlug = exports.fetchTeam = exports.fetchTeams = exports.deserializeTeamPage = exports.deserializeTeam = exports.teamNameRegex = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _flatten = require('lodash/flatten');

var _flatten2 = _interopRequireDefault(_flatten);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _times = require('lodash/times');

var _times2 = _interopRequireDefault(_times);

var _slugify = require('slugify');

var _slugify2 = _interopRequireDefault(_slugify);

var _client = require('../../utils/client');

var client = _interopRequireWildcard(_client);

var _pages = require('../pages');

var _params = require('../../utils/params');

var _justgiving = require('../../utils/justgiving');

var _totals = require('../../utils/totals');

var _base = require('../../utils/base64');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var teamNameRegex = exports.teamNameRegex = /[^\w\s'"!?£$€¥.,-]/gi;

var deserializeTeam = exports.deserializeTeam = function deserializeTeam(team) {
  var members = (0, _get2.default)(team, 'membership.members', []);
  var membersFitness = (0, _get2.default)(team, 'fitness.pages', []);

  return {
    active: team.status === 'active',
    campaign: (0, _get2.default)(team, 'campaign.title'),
    campaignId: (0, _get2.default)(team, 'campaign.campaignGuid'),
    charity: (0, _get2.default)(team, 'charity.name'),
    charityId: (0, _get2.default)(team, 'charity.charityId'),
    event: team.eventId,
    fitnessDistanceTotal: (0, _get2.default)(team, 'fitness.totalAmount', 0),
    fitnessDurationTotal: (0, _get2.default)(team, 'fitness.totalAmountTaken', 0),
    id: team.teamGuid,
    image: (0, _justgiving.imageUrl)(team.coverPhotoImageId || team.coverImageName),
    leader: [(0, _get2.default)(team, 'captain.firstName'), (0, _get2.default)(team, 'captain.lastName')].join(' '),
    members: members.map(function (member) {
      var page = (0, _pages.deserializePage)(member);
      var pageFitness = (0, _find2.default)(membersFitness, function (p) {
        return p.ID === page.uuid;
      }) || {};

      return _extends({}, page, {
        fitnessDistanceTotal: pageFitness.TotalValue || 0
      });
    }),
    name: team.name,
    owner: (0, _get2.default)(team, 'captain.userGuid'),
    pages: members.map(function (page) {
      return page.fundraisingPageGuid || page.pageGuid;
    }),
    raised: (0, _get2.default)(team, 'donationSummary.totalAmount'),
    slug: team.shortName && team.shortName,
    story: team.story && (0, _justgiving.parseText)(team.story),
    target: (0, _get2.default)(team, 'fundraisingConfiguration.targetAmount'),
    url: team.shortName && (0, _justgiving.baseUrl)() + '/team/' + team.shortName,
    uuid: team.teamGuid
  };
};

var deserializeTeamPage = exports.deserializeTeamPage = function deserializeTeamPage(page) {
  var currencyCode = (0, _get2.default)(page, 'targetWithCurrency.currencyCode');
  var totals = (0, _totals.deserializeTotals)((0, _get2.default)(page, 'totals.timeline', []), currencyCode);

  return _extends({}, totals, {
    active: page.status === 'ACTIVE',
    createdAt: page.createDate,
    currencyCode: currencyCode,
    donationUrl: (0, _justgiving.baseUrl)('www') + '/fundraising/' + page.slug + '/donate',
    id: page.eventGivingGroupId,
    image: (0, _get2.default)(page, 'cover.url') ? (0, _get2.default)(page, 'cover.url') + '?template=Size186x186Crop' : 'https://assets.blackbaud-sites.com/images/supporticon/user.svg',
    name: page.title,
    owner: (0, _get2.default)(page, 'owner.name'),
    raised: (0, _totals.getMonetaryValue)((0, _get2.default)(page, 'donationSummary.totalAmount')),
    slug: page.slug,
    status: page.status.toLowerCase(),
    subtitle: (0, _get2.default)(page, 'owner.name'),
    story: page.story,
    target: (0, _totals.getMonetaryValue)(page.targetWithCurrency),
    url: page.url,
    type: 'individual',
    uuid: page.legacyId
  });
};

var recursivelyFetchTeams = function recursivelyFetchTeams(_ref) {
  var CampaignGuid = _ref.CampaignGuid,
      Take = _ref.Take,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset,
      _ref$results = _ref.results,
      results = _ref$results === undefined ? [] : _ref$results;

  var params = {
    CampaignGuid: CampaignGuid,
    Take: Take,
    offset: offset
  };
  return client.servicesAPI.get('/v1/justgiving/proxy/campaigns/v1/teams/search', {
    params: params,
    paramsSerializer: _params.paramsSerializer
  }).then(function (response) {
    return response.data;
  }).then(function (data) {
    var next = data.next;

    var offset = next && next.split('offset=')[1];
    var updatedResults = [].concat(_toConsumableArray(results), _toConsumableArray(data.results));
    if (offset) {
      return recursivelyFetchTeams({
        CampaignGuid: CampaignGuid,
        Take: Take,
        offset: offset,
        results: updatedResults
      });
    } else {
      return updatedResults;
    }
  });
};

var fetchTeams = exports.fetchTeams = function fetchTeams() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var allTeams = options.allTeams,
      _options$campaign = options.campaign,
      campaign = _options$campaign === undefined ? (0, _params.required)() : _options$campaign,
      _options$limit = options.limit,
      limit = _options$limit === undefined ? 100 : _options$limit;


  var params = {
    CampaignGuid: campaign,
    Take: limit
  };
  if (allTeams) {
    return recursivelyFetchTeams(params);
  } else {
    return client.servicesAPI.get('/v1/justgiving/proxy/campaigns/v1/teams/search', {
      params: params,
      paramsSerializer: _params.paramsSerializer
    }).then(function (response) {
      return response.data.results;
    });
  }
};

var fetchTeam = exports.fetchTeam = function fetchTeam() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return client.servicesAPI.get('/v1/justgiving/proxy/campaigns/v1/teams/' + id + '/full').then(function (response) {
    return response.data;
  });
};

var fetchTeamBySlug = exports.fetchTeamBySlug = function fetchTeamBySlug() {
  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return client.servicesAPI.get('/v1/justgiving/proxy/campaigns/v1/teams/by-short-name/' + slug + '/full').then(function (response) {
    return response.data;
  }).then(function (team) {
    if (options.includeFitness) {
      return fetchTeamFitness(team.teamGuid, options.fitnessParams).then(function (fitness) {
        return _extends({}, team, { fitness: fitness });
      });
    }

    return team;
  }).then(function (team) {
    if (options.includePages) {
      var ids = team.membership.members.map(function (p) {
        return p.fundraisingPageGuid;
      });

      return (0, _pages.fetchPages)({ allPages: true, ids: ids }).then(function (members) {
        return _extends({}, team, {
          membership: _extends({}, team.membership, { members: members })
        });
      });
    }

    return Promise.resolve(team);
  });
};

var fetchTeamFitness = exports.fetchTeamFitness = function fetchTeamFitness(slug) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var params = {
    limit: options.fitnesslimit,
    start: options.startDate,
    end: options.endDate
  };

  return client.get('v1/fitness/teams/' + slug, params);
};

var fetchTeamPages = exports.fetchTeamPages = function fetchTeamPages(slug) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var limit = options.limit || 250;

  var query = '\n    query fetchTeamPages ($slug: Slug, $after: String) {\n      page(type: TEAM, slug: $slug) {\n        title\n        id\n        legacyId\n        type\n        membershipPolicy\n        relationships {\n          members (first: 10, after: $after) {\n            totalCount\n            nodes {\n              createDate\n              eventGivingGroupId\n              legacyId\n              slug\n              status\n              story\n              title\n              url\n              owner {\n                name\n                legacyId\n              }\n              donationSummary {\n                donationCount\n                offlineAmount {\n                  value\n                  currencyCode\n                }\n                totalAmount {\n                  value\n                  currencyCode\n                }\n              }\n              targetWithCurrency {\n                value\n                currencyCode\n              }\n              totals {\n                timeline {\n                  measurementDomain\n                  amounts {\n                    value\n                    unit\n                  }\n                }\n              }\n              cover {\n                ... on ImageMedia {\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ';

  return client.servicesAPI.post('/v1/justgiving/graphql', { query: query, variables: { slug: slug } }).then(function (response) {
    return (0, _get2.default)(response.data, 'data.page.relationships.members');
  }).then(function (data) {
    if (data.totalCount > 10) {
      // The maximum page size supported by this query is 10, so we're
      // generating a base64 encoded integer for page cursors up to the
      // total number of pages within the team (or a hard upper limit).
      // N.B. The cursor is zero-based, hence for 10-20 the cursor is 9.
      var pageCursors = (0, _times2.default)(Math.ceil(Math.min(data.totalCount, limit) / 10) - 1, function (integer) {
        return (0, _base.encodeBase64String)(integer * 10 + 9);
      });

      return Promise.all(pageCursors.map(function (after) {
        return client.servicesAPI.post('/v1/justgiving/graphql', {
          query: query,
          variables: { slug: slug, after: after }
        }).then(function (response) {
          return (0, _get2.default)(response.data, 'data.page.relationships.members');
        }).then(function (data) {
          return data.nodes;
        });
      })).then(function (pages) {
        return (0, _flatten2.default)([data.nodes].concat(_toConsumableArray(pages)));
      });
    }

    return data.nodes;
  });
};

var checkTeamSlugAvailable = exports.checkTeamSlugAvailable = function checkTeamSlugAvailable() {
  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var _ref2 = arguments[1];
  var _ref2$authType = _ref2.authType,
      authType = _ref2$authType === undefined ? 'Bearer' : _ref2$authType,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token;

  var options = {
    headers: {
      Authorization: authType + ' ' + token,
      'x-api-key': client.instance.defaults.headers['x-api-key']
    }
  };

  return client.servicesAPI.get('/v1/justgiving/proxy/campaigns/v1/teams/shortNames/' + slug + '/isAvailable', options).then(function (response) {
    return response.data.isAvailable;
  }).then(function (isAvailable) {
    return isAvailable ? slug : appendIdToSlug(slug);
  }).catch(function () {
    return appendIdToSlug(slug);
  });
};

// Take an existing slug
// Trim it down it size so it does not exceed to limit of 50
// Append a small generated unique id
var appendIdToSlug = function appendIdToSlug(slug) {
  var trimmedSlug = slug.slice(0, 43);
  var randomId = Math.random().toString(36).slice(-6);

  return trimmedSlug + '-' + randomId;
};

var createTeam = exports.createTeam = function createTeam(params) {
  var _params$authType = params.authType,
      authType = _params$authType === undefined ? 'Bearer' : _params$authType,
      _params$name = params.name,
      name = _params$name === undefined ? (0, _params.required)() : _params$name,
      _params$campaignId = params.campaignId,
      campaignId = _params$campaignId === undefined ? (0, _params.required)() : _params$campaignId,
      _params$story = params.story,
      story = _params$story === undefined ? (0, _params.required)() : _params$story,
      _params$captainSlug = params.captainSlug,
      captainSlug = _params$captainSlug === undefined ? (0, _params.required)() : _params$captainSlug,
      coverPhotoId = params.coverPhotoId,
      slug = params.slug,
      _params$target = params.target,
      target = _params$target === undefined ? 1000 : _params$target,
      _params$targetType = params.targetType,
      targetType = _params$targetType === undefined ? 'Fixed' : _params$targetType,
      _params$targetCurrenc = params.targetCurrency,
      targetCurrency = _params$targetCurrenc === undefined ? 'GBP' : _params$targetCurrenc,
      _params$teamType = params.teamType,
      teamType = _params$teamType === undefined ? 'Open' : _params$teamType,
      _params$token = params.token,
      token = _params$token === undefined ? (0, _params.required)() : _params$token;


  if (authType === 'Basic') {
    throw new Error('Teams does not support basic authentication');
  }

  var payload = {
    campaignGuid: campaignId,
    captainPageShortName: captainSlug,
    coverPhotoId: coverPhotoId,
    name: name.replace(/’/g, "'").replace(teamNameRegex, '').substring(0, 255),
    story: story,
    targetCurrency: targetCurrency,
    targetType: targetType,
    teamShortName: slug || (0, _slugify2.default)(params.name, { lower: true, strict: true }),
    teamTarget: target,
    teamType: teamType
  };

  var options = {
    headers: {
      Authorization: authType + ' ' + token
    }
  };

  return checkTeamSlugAvailable(payload.teamShortName, { authType: authType, token: token }).then(function (teamShortName) {
    return client.put('/v2/teams', _extends({}, payload, { teamShortName: teamShortName }), options);
  }).then(function (res) {
    return res.errorMessage ? Promise.reject(new Error(res.errorMessage)) : res;
  }).then(function (res) {
    return fetchTeam(res.teamGuid);
  });
};

var joinTeam = exports.joinTeam = function joinTeam(_ref3) {
  var _ref3$authType = _ref3.authType,
      authType = _ref3$authType === undefined ? 'Bearer' : _ref3$authType,
      pageId = _ref3.pageId,
      _ref3$pageSlug = _ref3.pageSlug,
      pageSlug = _ref3$pageSlug === undefined ? (0, _params.required)() : _ref3$pageSlug,
      teamId = _ref3.teamId,
      _ref3$teamSlug = _ref3.teamSlug,
      teamSlug = _ref3$teamSlug === undefined ? (0, _params.required)() : _ref3$teamSlug,
      _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token;

  if (authType === 'Basic') {
    throw new Error('Teams does not support basic authentication');
  }

  var payload = {
    pageId: pageId,
    pageSlug: pageSlug,
    teamId: teamId,
    teamSlug: teamSlug
  };

  var options = {
    headers: {
      Authorization: authType + ' ' + token,
      'x-api-key': client.instance.defaults.headers['x-api-key'],
      'x-application-key': client.instance.defaults.headers['x-application-key']
    }
  };

  return client.servicesAPI.post('/v1/justgiving/teams/join', payload, options).then(function (response) {
    return response.data;
  });
};

var leaveTeam = exports.leaveTeam = function leaveTeam(_ref4) {
  var _ref4$authType = _ref4.authType,
      authType = _ref4$authType === undefined ? 'Bearer' : _ref4$authType,
      _ref4$pageSlug = _ref4.pageSlug,
      pageSlug = _ref4$pageSlug === undefined ? (0, _params.required)() : _ref4$pageSlug,
      _ref4$teamSlug = _ref4.teamSlug,
      teamSlug = _ref4$teamSlug === undefined ? (0, _params.required)() : _ref4$teamSlug,
      _ref4$token = _ref4.token,
      token = _ref4$token === undefined ? (0, _params.required)() : _ref4$token;

  if (authType === 'Basic') {
    throw new Error('Teams does not support basic authentication');
  }

  var options = {
    headers: {
      Authorization: authType + ' ' + token,
      'x-api-key': client.instance.defaults.headers['x-api-key'],
      'x-application-key': client.instance.defaults.headers['x-application-key']
    }
  };

  return client.servicesAPI.post('/v1/justgiving/teams/leave', { pageSlug: pageSlug, teamSlug: teamSlug }, options).then(function (response) {
    return response.data;
  });
};

var updateTeam = exports.updateTeam = function updateTeam() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var _ref5 = arguments[1];
  var _ref5$name = _ref5.name,
      name = _ref5$name === undefined ? (0, _params.required)() : _ref5$name,
      _ref5$token = _ref5.token,
      token = _ref5$token === undefined ? (0, _params.required)() : _ref5$token,
      _ref5$currency = _ref5.currency,
      currency = _ref5$currency === undefined ? 'GBP' : _ref5$currency,
      image = _ref5.image,
      target = _ref5.target,
      story = _ref5.story;

  var headers = { Authorization: 'Bearer ' + token };
  var prepareStory = function prepareStory(story) {
    return '[{"type":"paragraph","nodes":[{"type":"text","ranges":[{"text":"' + story + '"}]}]}]';
  };
  var update = function update(url, data) {
    return client.servicesAPI.put('/v1/justgiving/proxy/campaigns/v1/teams/' + id + '/' + url, data, { headers: headers });
  };

  if (token.length > 32) {
    return Promise.all([update('details/name', {
      name: name.replace(teamNameRegex, '').substring(0, 255),
      teamGuid: id
    }), (story || image) && update('details', {
      coverPhotoImageId: image,
      story: prepareStory(story)
    }), target && update('fundraising', {
      targetAmount: target,
      currencyCode: currency
    })].filter(Boolean));
  }

  var payload = {
    teamGuid: id,
    coverPhotoId: image,
    currency: currency,
    name: name.replace(teamNameRegex, '').substring(0, 255),
    story: story,
    targetAmount: target
  };

  return client.put('/v1/teamsv2/' + id, payload, { headers: headers });
};